// src/utils/leadMagnetData.js
// Shared facts for the free lead-magnet cheat sheet, used by both the PDF
// generator (generateLeadMagnet.js) and the HTML page (pages/FreeCheatSheet.js)
// so the two versions never drift out of sync.

export const TOP_KEY_DATES = [
    ['1215', 'Magna Carta', 'King John forced to accept limits on royal power.'],
    ['1689', 'Bill of Rights', 'Confirmed Parliament\'s rights; monarch must be Protestant.'],
    ['1707', 'Acts of Union', 'England and Scotland united under one Parliament.'],
    ['1801', 'Act of Union with Ireland', 'Formed the United Kingdom of Great Britain and Ireland.'],
    ['1833', 'Emancipation Act', 'Abolished slavery throughout the British Empire.'],
    ['1867', 'Second Reform Act', 'Extended the vote to many more urban men.'],
    ['1918', 'Representation of the People Act', 'Vote extended to women over 30.'],
    ['1928', 'Equal Franchise Act', 'Vote extended to all men and women over 21.'],
    ['1948', 'NHS founded', 'Free healthcare at the point of use, led by Nye Bevan.'],
    ['1969', 'Voting age lowered to 18', 'Reduced from 21 to 18.'],
    ['1998', 'Good Friday Agreement & Human Rights Act', 'NI peace process; ECHR incorporated into UK law.'],
    ['2016', 'EU referendum ("Brexit")', 'UK voted 51.9% to 48.1% to leave the EU.'],
];

export const PATRON_SAINTS = [
    ['England', 'St George', '23 April', 'Not a public holiday'],
    ['Scotland', 'St Andrew', '30 November', 'Official public holiday'],
    ['Wales', 'St David', '1 March', 'Not a public holiday'],
    ['Northern Ireland', 'St Patrick', '17 March', 'Official public holiday'],
];

// Sample questions for the free cheat sheet.
//
// Deliberately drawn from topics the sheet's own tables do NOT cover
// (Government & Parliament, Law & Justice, Culture, Modern Britain). A reader
// who has just memorised 12 dates and 4 saints discovers the real test asks
// about driving ages and local councils too. That is the honest way to show the
// gap: demonstrate it rather than claim it.
//
// Copied verbatim from mockExamsData.js — single-answer questions only, kept
// short enough to fit the page. `correct` is the index into `choices`, matching
// the exam-bank format exactly. If a question is edited in the bank, update it
// here too, or the free sheet will teach a wrong answer.
export const SAMPLE_QUESTIONS = [
    {
        q: 'Councillors on local councils in the UK reach office through which process?',
        choices: ['Appointment by central government', 'Appointment by the monarch', 'Selection by lottery', 'Democratic election'],
        correct: 3,
    },
    {
        q: 'From what age can a person hold a licence to drive a car in the UK?',
        choices: ['16', '17', '18', '21'],
        correct: 1,
    },
    {
        q: "The Grand National, one of the UK's most famous horse races, is held near which city?",
        choices: ['Liverpool', 'Manchester', 'London', 'Edinburgh'],
        correct: 0,
    },
    {
        q: 'Which Labour politician became Prime Minister in 1997?',
        choices: ['Gordon Brown', 'Clement Attlee', 'Harold Wilson', 'Tony Blair'],
        correct: 3,
    },
];
